import React, { useState } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import style from './cardsCoins.module.css'
import Pagination from 'react-bootstrap/Pagination';
import { myPagination } from '../../constants/mainFunctions';


export default function CardCurrentItemsComponent(props) {

    const mLink = props?.coinLink

    const [myImgId, setMyImgId] = useState(null)

    const myLoader = ({ src, width, quality }) => {
        return `${src}?w=${width}&q=${quality || 75}`
    }

    const [mActive, setMactive] = useState(1)

    const itemsPerPage = 40

    const { pageNumber, pageArray } = myPagination(props, mActive, itemsPerPage)

    let items = [];

    for (let number = 1; number <= pageNumber; number++) {

        items.push(
            <Pagination.Item key={number} active={number === mActive} onClick={() => setMactive(number)}>
                {number}
            </Pagination.Item>,
        );
    }

    return (<>
        {pageArray?.length > 0 ?
            <React.Fragment>
                <article className='sectionOrArticleB'>
                    <Container>
                        <Row className='justify-content-xs-center  justify-content-md-start pt-1 pt-md-3 pt-lg-4'>
                            {pageArray?.map((e, i) => <Col xs={12} sm={6} md={4} lg={3} xl={2} key={i} className='mb-3 text-center' >
                                <Card style={{ maxWidth: '18rem', margin: '.3rem', height: '100%', marginLeft: 'auto', marginRight: 'auto' }} className='h-100 border-0'>
                                    <Link href={`/${mLink}/${e?.docId}`} passHref >
                                        <div className={style.container} >
                                            <div className={style.text}>
                                                {myImgId !== e?.docId ? <Image
                                                    src={`${e?.image2}`}
                                                    loader={myLoader}
                                                    alt={e?.title}
                                                    fill
                                                    priority={true}
                                                    sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                    className='cardImage'
                                                    onMouseEnter={() => {
                                                        setMyImgId(e?.docId)
                                                    }}
                                                    onMouseLeave={() => setMyImgId(null)}
                                                /> :
                                                    <Image
                                                        src={`${e?.image1}`}
                                                        loader={myLoader}
                                                        alt={e?.title}
                                                        fill
                                                        priority={true}
                                                        sizes="(max-width: 768px) 100vw,
                                        (max-width: 1200px) 50vw,
                                        33vw"
                                                        quality={100}
                                                        className='cardImage'
                                                        onMouseEnter={() => {
                                                            setMyImgId(e?.docId)
                                                        }}
                                                        onMouseLeave={() => setMyImgId(null)}
                                                    />}
                                            </div>
                                        </div>
                                        <Card.Body >
                                            <p className={style.cardsDescription}>{e?.title}</p>
                                        </Card.Body>
                                    </Link>
                                </Card>
                            </Col>)
                            }
                        </Row>
                    </Container>
                    <Container>
                        <Row className='justify-content-center'>
                            <Col className='justify-content-center'>
                                <article className='sectionOrArticleT d-flex justify-content-center'>
                                    <Pagination size="sm">{items}</Pagination>
                                </article>
                            </Col>
                        </Row>
                    </Container>
                </article>
            </React.Fragment> :
            null}
    </>
    )
}